<template>

  <div class="d-flex flex-column" v-if="currentProjectPk">

    <pulse-loader :loading="Boolean(spinnerEnabledCounter)" color="#3990d8" size="30px"></pulse-loader>

    <!-- SUMMARY (START) -->
    <GmbDisplayHeading isSecondary text="Sections du PDF à générer">
      <template>
        <FdText colorTheme3 fa>
          <i class="fa-solid fa-table-list"/>
        </FdText>
      </template>
    </GmbDisplayHeading>

    <div class="d-flex mt-3"></div>

    <!--div class="row no-gutters">
      <div class="d-flex col-9 pr-3 flex-column">
        <div class="row flex-grow-1 h-0 no-gutters">
          <div class="d-flex mx-0 container-xl px-0 flex-column">
            <GmbRow-->
    <div class="row m-n1 py-1 align-items-center no-gutters"
         v-for="(sectionObj, sectionIdx) in reportingSections"
    >
      <div class="col-2 p-1">
        <FdText class="gmb-column-label" tag="label"
        >{{ sectionObj.section_creation_date.toLocaleString() }}
        </FdText
        >
      </div>

      <div class="col-1 p-1">
        <FdText class="gmb-column-label" tag="label"
        >{{ translateSectionTypeForDisplay(sectionObj.section_type) }}
        </FdText
        >
      </div>

      <div class="col-2 p-1">
        <input v-model="sectionObj.chapter_label"
               :placeholder="getChapterLabelPlaceholder(sectionIdx, sectionObj)"
               size="30" maxlength="100" class="mw-100"/>
        <!--FdText class="gmb-column-label" tag="label"
          >{{sectionObj.section_label}}</FdText
        -->
      </div>

      <div class="col-2 p-1">
        <input v-if="sectionObj.section_type == 'map'"
            v-model="sectionObj.section_label" placeholder="Titre de carte (préconisé)" size="30" maxlength="100" class="mw-100"/>
      </div>

      <div class="col-auto p-1">
        <input type="checkbox" :id="'data_selection_checkbox_' + sectionIdx" class="mw-100"
               v-model="sectionObj.skip_data_selection_page"/>
        <label :for="'data_selection_checkbox_' + sectionIdx" style="margin: 0 5px">Masquer la page d'échantillon de données</label>
      </div>

      <div class="col-auto p-1">
        <b-button
            class="d-flex ml-2 p-0 justify-content-center align-items-center text-size-reset rounded-1 gmb-map-zoom-control"
            variant="primary"
            :disabled="(sectionIdx === 0)"
            @click="moveReportingSectionUp(sectionIdx)"
        >
          <FdText fa>
            <i class="fa-solid fa-up"/>
          </FdText>
        </b-button>
      </div>
      <div class="col-auto p-1">
        <b-button
            class="d-flex ml-2 p-0 justify-content-center align-items-center text-size-reset rounded-1 gmb-map-zoom-control"
            variant="primary"
            :disabled="(sectionIdx === reportingSections.length-1)"
            @click="moveReportingSectionDown(sectionIdx)"
        >
          <FdText fa>
            <i class="fa-solid fa-down"/>
          </FdText>
        </b-button>
      </div>
      <div class="col-auto p-1">
        <b-button
            class="d-flex ml-2 p-0 justify-content-center align-items-center text-size-reset rounded-1 gmb-map-zoom-control"
            variant="primary"
            @click="deleteReportingSection(sectionIdx)"
        >
          <FdText fa>
            <i class="fa-solid fa-trash"/>
          </FdText>
        </b-button>
      </div>
    </div>

    <div v-if="reportingSections.length === 0"
         class="row m-n1 py-1 align-items-center no-gutters">
      <div class="col-auto p-1">
        <FdText tag="label" italic>Aucune section de carte ou de statistiques n'a encore été ajoutée pour être exportée en
          PDF.
        </FdText>
      </div>
    </div>
    <!--/GmbRow>
  </div>
</div>
</div>
</div-->

    <div class="d-flex mt-3"></div>

    <div
        class="row m-n1 py-1 align-items-center no-gutters">
      <div class="col-auto p-1">
        <label v-if="hasUnexportedChanges()"><i>Des données sont en attente d'export</i></label>
        <b-button
            class="d-flex p-1 justify-content-center align-items-center text-size-reset rounded-1"
            variant="primary"
            @click="generateAndDownloadPdf"
            :disabled="!isPdfReadyToGenerate"
        >
          <FdText fa><i class="fas fa-download"/></FdText>
          <FdText class="mx-2" tag="span">Télécharger</FdText>
        </b-button>
      </div>
    </div>

    <div
        v-if="reportingSections.length"
        class="row m-n1 py-1 align-items-center no-gutters">
      <div class="col-auto p-1">
        <br>
        <p>
          <i>
            Un "titre de chapitre" couvre la section actuelle et les suivantes jusqu'au prochain titre de chapitre. <br>
            Le premier titre de chapitre est obligatoire, et il sert de sous-titre au rapport s'il est le seul
            présent.<br>
            Un nouveau chapitre est automatiquement inséré lorsque le type de section (Indicateurs ou Carte) change, il est donc préconisé de lui donner un titre manuellement.<br>
            Si plusieurs titres de chapitre existent (automatiques ou non), le sommaire du PDF se base sur ces titres ; sinon il se base
            uniquement sur les sous-sections implicites (échantillon sélectionné, données de référence...).<br>
            Si un même échantillon de données est utilisée pour plusieurs sections successives, il ne sera pas répété
            dans le PDF pour le même chapitre. Il est possible de forcer le masquage d'une page d'échantillon de données
            peu intéressante, avec la case à cocher dédiée.<br>
          </i>
        </p>
      </div>
    </div>

  </div>

</template>

<script>
import {BACKEND_API_URL, triggerDownloadOfBinaryData, postApiEndpoint} from "@/services/base";
import FdScroll from "@/flexdesign/Scroll";
import FdText from "@/flexdesign/Text";

import _ from "lodash";
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import GmbDisplayCell from "@/widgets/DisplayCell";
import GmbDisplayHeading from "@/widgets/DisplayHeading";
import GmbNotificationMessage from "@/widgets/NotificationMessage";
import GmbRow from "@/widgets/Row";
import GmbSection from "@/widgets/Section";
import GmbSticker from "@/widgets/Sticker";
import {openToast, base64toBlob} from "@/helpers.js";

export default {
  name: "GmbReporting",

  components: {
    PulseLoader,

    FdScroll,
    FdText,

    GmbDisplayCell,
    GmbDisplayHeading,
    GmbNotificationMessage,
    GmbRow,
    GmbSection,
    GmbSticker,
  },

  props: {
    currentProjectPk: Number,
    currentOrganizationPk: Number,  // Might be undefined if we're at project level
  },

  data() {
    return {
      spinnerEnabledCounter: 0,
      reportingSections: [
        /*
        {section_type: "statistics",
         section_label: "SECTION 1 stats",
         section_creation_date: new Date()},
        {section_type: "map",
         section_label: "SECTION 2 map",
         section_creation_date: new Date()},
         */

      ],  // Will contain 1 object per Stats/Map snapshot
      previouslyExportedReportingSections: null,
    };
  },

  computed: {
    isPdfReadyToGenerate() {
      return (this.reportingSections.length > 0 &&
          this.reportingSections[0].chapter_label.trim())
    }
  },

  watch: {
    currentProjectPk() {
      this.reportingSections = [];  // RESET
    },
  },

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
    window.addEventListener("beforeunload", this.preventDataLoss)
  },


  mounted() {
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
    window.removeEventListener("beforeunload", this.preventDataLoss);
  },

  unmounted() {
  },

  methods: {

    translateSectionTypeForDisplay(section_type) {
      return section_type == "map" ? "Carte" : "Indicateurs"
    },

    getChapterLabelPlaceholder(sectionIdx, sectionObj) {
      if (sectionIdx == 0)
        return 'Premier titre de chapitre (obligatoire)';
      var previouSectionObj = this.reportingSections[sectionIdx-1];
      var isNewSectionType = (sectionObj.section_type != previouSectionObj.section_type);
      return isNewSectionType ? 'Titre de chapitre (préconisé)' : 'Titre de chapitre (facultatif)';
    },

    hasUnexportedChanges() {
      return this.reportingSections.length && !_.isEqual(this.previouslyExportedReportingSections, this.reportingSections);
    },

    preventDataLoss(event) {
      if (!this.hasUnexportedChanges()) return;  // Nothing on workbench or PDF already exported
      event.preventDefault();
      event.returnValue = "Données en cours pour export PDF";  // Probably not displayed by browser
      return event.returnValue;  // Maybe necessary for some browsers...
    },

    appendReportingSection(type, obj) {
      openToast("Opération terminée", "Nouvelle section ajouté à l'export : " + this.translateSectionTypeForDisplay(type));
      let now = new Date();
      this.reportingSections.push(
          {
            section_type: type,
            section_label: "", // Optional, used as map title for example
            section_creation_date: now,
            section_data: obj,
            chapter_label: "",  // Triggers creation of a chapter covering several next sections
            skip_data_selection_page: false
          }
      );
    },
    deleteReportingSection(idx) {
      if (window.confirm("Êtes-vous sûr de vouloir supprimer cette section de l'export ?"))
        this.reportingSections.splice(idx, 1);
    },
    moveReportingSectionUp(idx) {
      let [sectionObj] = this.reportingSections.splice(idx, 1);
      this.reportingSections.splice(idx - 1, 0, sectionObj);
    },
    moveReportingSectionDown(idx) {
      let [sectionObj] = this.reportingSections.splice(idx, 1);
      this.reportingSections.splice(idx + 1, 0, sectionObj);
    },
    generateAndDownloadPdf() {
      //console.log(">> generateAndDownloadPdf", JSON.stringify(this.reportingSections));
      this.spinnerEnabledCounter += 1;
      let urlSuffix = `api/pdf-report-export/`;
      let pdfGenerationUrl = new URL(urlSuffix, BACKEND_API_URL).href;

      let postData = {
        projectPk: this.currentProjectPk,
        organizationPk: this.currentOrganizationPk || null,
        reportingSections: this.reportingSections
      }

      // FOR DEBUGGING: console.log("POST DATA REPORTING SECTIONS", this.reportingSections);

      postApiEndpoint(pdfGenerationUrl, postData).then((response) => {
        let dataObj = response.data;
        //console.log("Response DATA object", dataObj);

        this.previouslyExportedReportingSections = structuredClone(this.reportingSections);

        let blob = base64toBlob(dataObj.pdf_file_b64, "application/pdf");
        //let pdfBytes = atob(dataObj.pdf_file_b64);
        //console.log("Decode pdf bytes", pdfBytes, typeof pdfBytes);
        //pdfBytes = base64toBlob(pdfBytes, "application/pdf")

        triggerDownloadOfBinaryData(blob, "project_report.pdf");
      }).finally(() => {
        this.spinnerEnabledCounter -= 1;
      });

      /*rawGetUrl(downloadUrl).then((response) => {

      });*/

    }
  },
};
</script>

<style lang="scss"></style>
